import Link from 'next/link';
import FavouriteButton from '#components/controls/buttons/favouriteButton/FavouriteButton';
import { getMediabox, ImageRendererTypes } from '#config';
import Mediabox from '#components/common/mediabox/Mediabox';
import s from '#components/teasers/default-teaser/DefaultTeaser.module.scss';
import { useOvermindState } from '#store/overmind';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { ITeaserRenderer } from '#components/lists/horizontal-scroll-list/HorizontalScrollList';
import { getRoute } from '#utils';
import EpisodeInfos from '#components/common/teaser-meta/EpisodeInfos';
import TeaserTitle from '#components/common/teaser-meta/TeaserTitle';
import TeaserTextBox from '#components/common/teaser-meta/TeaserTextBox';
import TeaserOverline from '#components/common/teaser-meta/TeaserOverline';
import { Media, MediaType } from '#types/generated/graphql-types';
import useTranslation from 'next-translate/useTranslation';

interface DefaultTeaserProps extends ITeaserRenderer {
  teaserDataRaw: Media;
}

const DefaultTeaser: FC<DefaultTeaserProps> = ({ teaserDataRaw }) => {
  const router = useRouter();
  const { t } = useTranslation();
  const { isLoggedIn } = useOvermindState().user;

  const mediabox = getMediabox(
    ImageRendererTypes.Teaser,
    teaserDataRaw.teaserImage || teaserDataRaw.logoImage,
    true
  );

  const handleClick = () => {
    router.push(getRoute(teaserDataRaw, t));
  };

  const mediaType = teaserDataRaw.mediaType;

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
    <article className={`${s.host}`} onClick={handleClick}>
      <div className={s.media}>
        <Mediabox {...mediabox} />
        {isLoggedIn && teaserDataRaw.iri && (
          <div className={s.buttonAdd}>
            <FavouriteButton item={teaserDataRaw} isSizeSmall />
          </div>
        )}
      </div>

      <TeaserTextBox classes="tw-pb-2">
        <Link href={getRoute(teaserDataRaw, t)} legacyBehavior>
          <a className={s.link}>
            <TeaserOverline>
              {mediaType === MediaType.Episode && (
                <>{teaserDataRaw?.season?.series?.title || ''}</>
              )}
              {mediaType === MediaType.Standalone && (
                <>
                  {teaserDataRaw.categories
                    .map((category) => category.title)
                    .join(' | ')}
                </>
              )}
            </TeaserOverline>

            <TeaserTitle size="small" lines={2}>
              <EpisodeInfos data={teaserDataRaw} hideSeasonInfo={true} />
              {teaserDataRaw.title}
            </TeaserTitle>
          </a>
        </Link>
      </TeaserTextBox>
    </article>
  );
};

export default DefaultTeaser;
